import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NAVY = "#0A1628"; const GOLD = "#D4AF37"; const GREEN = "#1A7A4A";
const GREY = "#5a5d66"; const BG = "#F8F9FA";

const PLANS = [
  { value: "", label: "All plans" },
  { value: "starter", label: "Starter $49" },
  { value: "growth", label: "AutoPilot $97" },
  { value: "pro", label: "AutoPilot Pro $149" },
  { value: "elite", label: "Elite $299" },
  { value: "market_leader", label: "Market Leader $599" },
];

const fmtDate = (s) => s ? new Date(s).toLocaleString(undefined, {
  month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
}) : "—";
const splitName = (full) => {
  if (!full) return ["", ""];
  const parts = full.trim().split(/\s+/);
  return parts.length === 1 ? [parts[0], ""] : [parts[0], parts.slice(1).join(" ")];
};

const AdminSubscribers = () => {
  const [q, setQ] = useState("");
  const [plan, setPlan] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/admin/subscribers`, { params: { q, plan, limit: 500 } });
      setData(r.data);
    } catch (e) { setData({ items: [], count: 0 }); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []); // initial

  const onSearch = (e) => {
    e.preventDefault();
    load();
  };

  const exportCsv = () => {
    if (!data?.items?.length) return;
    const header = "first_name,last_name,email,phone,city,state,trade,plan,leads_count,last_lead_at,created_at\n";
    const rows = data.items.map((c) => {
      const [first, last] = splitName(c.owner_name);
      return [first, last, c.email || "", c.phone || "",
              c.city || "", "RI", c.trade || "", c.plan || "",
              c.leads_count, c.last_lead_at || "", c.created_at || ""]
        .map((v) => `"${String(v).replace(/"/g, '""')}"`).join(",");
    });
    const blob = new Blob([header + rows.join("\n")], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `nearnow-subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
  };

  return (
    <div data-testid="admin-subscribers-page" style={{ minHeight: "100vh", background: BG, padding: "30px 22px 80px" }}>
      <div style={{ maxWidth: 1400, margin: "0 auto" }}>
        <p style={{ color: GOLD, letterSpacing: 4, fontSize: 13, fontFamily: "Bebas Neue, sans-serif", margin: 0 }}>
          ADMIN · PAID SUBSCRIBERS
        </p>
        <h1 className="font-display" style={{ fontSize: 52, color: NAVY, letterSpacing: 1, margin: "6px 0 4px" }}>
          ALL PAID SUBSCRIBERS
        </h1>

        <form onSubmit={onSearch} style={{ marginTop: 16, display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
          <input data-testid="subscribers-search" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search by name, email, city, trade, phone…"
            style={{ flex: 1, minWidth: 260, minHeight: 48, fontSize: 15, padding: "0 14px",
                     border: `1px solid #cbd0db`, borderRadius: 8 }} />
          <select data-testid="subscribers-plan-filter" value={plan} onChange={(e) => setPlan(e.target.value)}
            style={{ minHeight: 48, fontSize: 14, padding: "0 14px",
                     border: `1px solid #cbd0db`, borderRadius: 8 }}>
            {PLANS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
          </select>
          <button data-testid="subscribers-search-btn" type="submit" className="btn-gold tap"
            style={{ minHeight: 48, paddingLeft: 22, paddingRight: 22 }}>SEARCH</button>
          <button data-testid="subscribers-csv-btn" type="button" onClick={exportCsv} className="btn-outline-navy tap"
            style={{ minHeight: 48, paddingLeft: 18, paddingRight: 18 }}>⬇ CSV</button>
        </form>

        <div style={{ marginTop: 18, background: "#fff", borderRadius: 12, padding: 0, overflow: "hidden",
                       boxShadow: "0 12px 30px rgba(10,22,40,0.06)" }}>
          <div style={{ padding: "12px 18px", borderBottom: `1px solid ${BG}`, fontSize: 13, color: GREY }}>
            {data ? `${data.count} subscriber${data.count === 1 ? "" : "s"}` : "Loading…"}
          </div>
          {loading || !data ? (
            <div style={{ padding: 30, textAlign: "center", color: GREY }}>Loading…</div>
          ) : data.items.length === 0 ? (
            <div style={{ padding: 30, textAlign: "center", color: GREY }}>No matching subscribers.</div>
          ) : (
            <table data-testid="subscribers-table" style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: BG }}>
                  <Th>FIRST</Th><Th>LAST</Th><Th>EMAIL</Th><Th>CITY · STATE</Th>
                  <Th>TYPE</Th><Th>PLAN</Th><Th align="right">LEADS</Th><Th align="right">LAST LEAD</Th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((c) => {
                  const [first, last] = splitName(c.owner_name);
                  return (
                    <tr key={c.id} data-testid={`subscriber-row-${c.id}`} style={{ borderTop: `1px solid ${BG}` }}>
                      <td style={cell}><strong>{first}</strong></td>
                      <td style={cell}>{last}</td>
                      <td style={cell}>
                        <a href={`mailto:${c.email}`} style={{ color: NAVY }}>{c.email || "—"}</a><br/>
                        <span style={{ fontSize: 11, color: GREY }}>{c.phone || ""}</span>
                      </td>
                      <td style={cell}>{c.city || "—"}, RI</td>
                      <td style={cell}>{c.trade || "—"}</td>
                      <td style={cell}>
                        <span style={{ display: "inline-block", padding: "3px 8px", background: NAVY, color: GOLD,
                                         borderRadius: 999, fontSize: 11, letterSpacing: 1.5,
                                         fontFamily: "Bebas Neue, sans-serif", textTransform: "uppercase" }}>
                          {(c.plan || "—").replace(/_/g, " ")}
                        </span>
                      </td>
                      <td style={{ ...cell, textAlign: "right", fontWeight: 700, color: c.leads_count > 0 ? GREEN : GREY }}>
                        {c.leads_count}
                      </td>
                      <td style={{ ...cell, textAlign: "right", fontSize: 12, color: GREY }}>
                        {fmtDate(c.last_lead_at)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

const Th = ({ children, align }) => (
  <th style={{ textAlign: align || "left", padding: "12px 14px", fontSize: 11,
    color: GREY, letterSpacing: 1.5, fontFamily: "Bebas Neue, sans-serif" }}>{children}</th>
);
const cell = { padding: "12px 14px", verticalAlign: "middle" };

export default AdminSubscribers;
